import React from 'react';
import Header from '../homepage/Header';
import Footer from '../homepage/Footer';
import './index.css';

function TermsOfService() {
  return (
    <div className="position-relative">
      <Header />
      <div className="terms-of-service-container">
        <section className="terms-of-service container">
          <h1 className="mb-4">SHOOT TERMS OF SERVICE</h1>
          <p className="last-updated mb-4">Last Updated: January 7, 2026</p>

          <p className="mb-4">
            These Terms of Service (&quot;Terms&quot;) govern access to and use of the websites,
            {' '}
            applications, software agents, and related services offered by Shoot Software
            Corporation (Shoot Software, Inc.), a Georgia company (&quot;Shoot,&quot; &quot;we,&quot;
            {' '}
            &quot;us,&quot; or &quot;our&quot;), including https://www.trustshoot.com and
            any associated subdomains, web applications, and downloadable applications
            (collectively, the &quot;Services&quot;).
          </p>

          <p className="mb-4">
            <strong>
              BY ACCESSING OR USING THE SERVICES, YOU AGREE TO THESE TERMS.
            </strong>
            {' '}
            If you do not agree, do not access or use the Services.
          </p>

          <p className="mb-5">
            If you are using the Services on behalf of a company, organization, or other
            entity (a &quot;Customer&quot;), you represent and warrant that you have
            authority to bind that Customer to these Terms. In that case, &quot;you&quot;
            and &quot;your&quot; refer to the Customer.
          </p>

          <h2 className="mb-3">1. THE AGREEMENT; OTHER DOCUMENTS</h2>
          <h3 className="mb-3">1.1 The Agreement.</h3>
          <p className="mb-4">
            These Terms, together with (a) our Privacy Policy, (b) the Shoot Data
            Processing Addendum (&quot;DPA&quot;) (when applicable), (c) any Order
            Form(s) or subscription terms presented through the Services, and (d) any
            other policies or written agreements expressly incorporated (collectively,
            the &quot;Agreement&quot;), govern your access to and use of the Services.
          </p>

          <h3 className="mb-3">1.2 Order of precedence.</h3>
          <p className="mb-2">If there is a conflict between documents:</p>
          <ul className="mb-4">
            <li>
              (a) an Order Form or other signed written agreement controls over these
              Terms as to that conflict;
            </li>
            <li>
              (b) the DPA controls over these Terms for privacy/data-processing matters
              covered by the DPA;
            </li>
            <li>
              (c) these Terms control over other website postings unless the posting
              expressly states otherwise.
            </li>
          </ul>

          <h3 className="mb-3">1.3 HIPAA / BAA.</h3>
          <p className="mb-5">
            If the parties enter into a separate Business Associate Agreement (&quot;BAA&quot;),
            {' '}
            the BAA governs Protected Health Information (&quot;PHI&quot;) to the extent
            applicable, and controls in the event of a conflict regarding PHI.
          </p>

          <h2 className="mb-3">2. DEFINITIONS</h2>
          <ul className="mb-5">
            <li>
              <strong>&quot;Authorized User&quot;</strong>
              {' '}
              means any individual authorized
              by Customer to use the Services (e.g., employees, contractors, agents).
            </li>
            <li>
              <strong>&quot;Customer Content&quot;</strong>
              {' '}
              means any data, information,
              files, text, images, logs, screenshots, metadata, or other content submitted
              to, collected by, or generated through the Services on Customer&apos;s behalf,
              including monitoring data (as configured).
            </li>
            <li>
              <strong>&quot;Documentation&quot;</strong>
              {' '}
              means user guides, help center
              materials, and other documentation we make available for the Services.
            </li>
            <li>
              <strong>&quot;Order Form&quot;</strong>
              {' '}
              means any ordering document, statement
              of work, or online checkout flow specifying subscription details, fees, term,
              and entitlements.
            </li>
            <li>
              <strong>&quot;Subscription Term&quot;</strong>
              {' '}
              means the subscription period
              (e.g., monthly or annual) specified in an Order Form or the Services.
            </li>
          </ul>

          <h2 className="mb-3">3. ELIGIBILITY; ACCOUNTS; SECURITY</h2>
          <h3 className="mb-3">3.1 Eligibility.</h3>
          <p className="mb-4">
            You must be at least 18 years old (or the age of majority in your jurisdiction)
            and able to form a binding contract.
          </p>

          <h3 className="mb-3">3.2 Account registration.</h3>
          <p className="mb-4">
            You must provide accurate, complete, and current information, and keep it updated.
          </p>

          <h3 className="mb-3">3.3 Account security.</h3>
          <p className="mb-5">
            You are responsible for maintaining the confidentiality of credentials and for
            all activity under your account. Notify us promptly if you suspect unauthorized
            access.
          </p>

          <h2 className="mb-3">
            4. THE SERVICES; CUSTOMER ADMINISTRATION; MONITORING FEATURES
          </h2>
          <h3 className="mb-3">4.1 Service description.</h3>
          <p className="mb-4">
            The Services provide workforce and operational tooling that may include
            (depending on configuration) time tracking, scheduling, attendance, productivity
            insights, application/URL tracking, screenshots, location/job site tools, unusual
            activity/security insights, reporting, and integrations.
          </p>

          <h3 className="mb-3">4.2 Customer admins; visibility.</h3>
          <p className="mb-4">
            Customers may designate administrators who can configure features, manage
            permissions, and access Customer Content. Depending on Customer settings,
            Customer Content (including monitoring outputs) may be visible to Customer&apos;s
            administrators and other roles designated by Customer.
          </p>

          <h3 className="mb-3">
            4.3 Workforce monitoring and legal compliance (Customer responsibility).
          </h3>
          <ul className="mb-4">
            <li>
              (a) Customer is solely responsible for ensuring that its use of the Services
              (including any monitoring features) complies with applicable laws,
              labor/employment requirements, workplace monitoring rules, privacy laws,
              and any notice/consent obligations.
            </li>
            <li>
              (b) Customer is also responsible for its internal policies, including
              informing Authorized Users what is enabled, when data collection occurs,
              and how data is used.
            </li>
            <li>
              (c) Shoot does not provide legal advice and does not determine Customer&apos;s
              lawful basis for monitoring.
            </li>
          </ul>

          <h3 className="mb-3">4.4 Authorized User acknowledgement.</h3>
          <p className="mb-5">
            If you are an Authorized User, you acknowledge that the Customer may enable
            monitoring features and access data according to its policies and permissions.
          </p>

          <h2 className="mb-3">5. ACCEPTABLE USE</h2>
          <p className="mb-2">
            You will not (and will not allow any Authorized User to):
          </p>
          <ul className="mb-5">
            <li>
              (a) violate any law or regulation;
            </li>
            <li>
              (b) use the Services for unlawful surveillance, discrimination, harassment,
              or retaliation;
            </li>
            <li>
              (c) access or attempt to access the Services or systems without authorization;
            </li>
            <li>
              (d) interfere with or disrupt the integrity or performance of the Services;
            </li>
            <li>
              (e) reverse engineer, decompile, or attempt to derive source code (except
              where prohibited by law);
            </li>
            <li>
              (f) circumvent security features, usage limits, or access controls;
            </li>
            <li>
              (g) upload malware or exploit the Services to transmit harmful code; or
            </li>
            <li>
              (h) infringe or misappropriate intellectual property or other rights.
            </li>
          </ul>
          <p className="mb-5">We may suspend or terminate access for violations.</p>

          <h2 className="mb-3">6. SUBSCRIPTIONS, FEES, BILLING, AND TAXES</h2>
          <h3 className="mb-3">6.1 Subscriptions.</h3>
          <p className="mb-4">
            Certain features require a paid subscription. Subscription details are described
            in an Order Form or the Services.
          </p>

          <h3 className="mb-3">6.2 Auto-renewal.</h3>
          <p className="mb-4">
            Unless otherwise stated, subscriptions renew automatically at the end of each
            Subscription Term. Customer may disable renewal or cancel as described in the
            Services or an Order Form. Cancellation prevents future charges but does not
            retroactively refund amounts already paid, except as required by law or
            expressly stated in an Order Form.
          </p>

          <h3 className="mb-3">6.3 Taxes.</h3>
          <p className="mb-4">
            Fees exclude taxes. Customer is responsible for applicable taxes, except where
            prohibited.
          </p>

          <h3 className="mb-3">6.4 Late payments.</h3>
          <p className="mb-5">
            If payments are overdue, we may suspend access until paid, where permitted.
          </p>

          <h2 className="mb-3">7. CUSTOMER CONTENT; LICENSE; RESPONSIBILITIES</h2>
          <h3 className="mb-3">7.1 Ownership.</h3>
          <p className="mb-4">
            As between the parties, Customer owns Customer Content.
          </p>

          <h3 className="mb-3">7.2 License to operate the Services.</h3>
          <p className="mb-2">
            Customer grants Shoot a limited, worldwide, non-exclusive license to host,
            process, transmit, display, and otherwise use Customer Content solely to:
          </p>
          <ul className="mb-4">
            <li>(a) provide, maintain, and secure the Services;</li>
            <li>(b) provide support and troubleshooting;</li>
            <li>(c) prevent or address fraud, security, or technical issues; and</li>
            <li>(d) comply with law.</li>
          </ul>

          <h3 className="mb-3">7.3 Customer responsibilities for Customer Content.</h3>
          <p className="mb-4">
            Customer represents and warrants that it has all rights and permissions necessary
            to provide Customer Content to Shoot and to authorize Shoot to process it under
            the Agreement.
          </p>

          <h3 className="mb-3">7.4 De-identified/aggregated data.</h3>
          <p className="mb-5">
            To the extent permitted by law, we may create and use aggregated or de-identified
            data derived from Customer Content for analytics, service improvement, benchmarking,
            and security purposes, provided it is not reasonably capable of identifying a person.
          </p>

          <h2 className="mb-3">8. DATA PROTECTION; PRIVACY; DPA</h2>
          <h3 className="mb-3">8.1 Privacy Policy.</h3>
          <p className="mb-4">
            Our Privacy Policy describes how we collect and use information related to the
            Services.
          </p>

          <h3 className="mb-3">8.2 Customer as controller; Shoot as processor.</h3>
          <p className="mb-4">
            Where Shoot processes Customer Personal Data on Customer&apos;s behalf, Customer
            is the controller (or business) and Shoot is the processor (or service provider),
            as further described in the DPA.
          </p>

          <h3 className="mb-3">8.3 DPA incorporation.</h3>
          <p className="mb-4">
            If Customer is subject to Data Protection Laws that require a data processing
            addendum, the Shoot DPA is incorporated into the Agreement and applies to the
            processing of Customer Personal Data.
          </p>

          <h3 className="mb-3">8.4 Separate BAA.</h3>
          <p className="mb-5">
            If the parties execute a BAA, the BAA governs PHI to the extent applicable.
          </p>

          <h2 className="mb-3">9. THIRD-PARTY SERVICES AND INTEGRATIONS</h2>
          <p className="mb-5">
            The Services may interoperate with third-party services (e.g., SSO, HR/payroll,
            ticketing, messaging, storage). Third-party services are governed by their own
            terms and privacy policies. Shoot is not responsible for third-party services.
          </p>

          <h2 className="mb-3">10. INTELLECTUAL PROPERTY; FEEDBACK</h2>
          <h3 className="mb-3">10.1 Our IP.</h3>
          <p className="mb-4">
            The Services (excluding Customer Content) are owned by Shoot or its licensors
            and protected by intellectual property laws.
          </p>

          <h3 className="mb-3">10.2 Limited license.</h3>
          <p className="mb-4">
            Subject to the Agreement, Shoot grants Customer and Authorized Users a limited,
            non-exclusive, non-transferable right to access and use the Services during the
            Subscription Term for Customer&apos;s internal business purposes.
          </p>

          <h3 className="mb-3">10.3 Feedback.</h3>
          <p className="mb-5">
            If you provide suggestions or feedback, you grant Shoot a perpetual, irrevocable,
            worldwide, royalty-free license to use it without restriction or compensation.
          </p>

          <h2 className="mb-3">11. SUSPENSION; TERMINATION</h2>
          <h3 className="mb-3">11.1 Suspension.</h3>
          <p className="mb-2">We may suspend access if we reasonably believe:</p>
          <ul className="mb-4">
            <li>(a) there is a security risk, fraud, or abuse;</li>
            <li>
              (b) continued use could harm the Services, other customers, or third parties; or
            </li>
            <li>(c) payment is overdue.</li>
          </ul>

          <h3 className="mb-3">11.2 Termination.</h3>
          <p className="mb-4">
            Either party may terminate as permitted by the Agreement or an Order Form.
          </p>

          <h3 className="mb-3">11.3 Effect of termination.</h3>
          <p className="mb-2">Upon termination:</p>
          <ul className="mb-5">
            <li>(a) access to the Services ends;</li>
            <li>
              (b) Customer remains responsible for fees incurred through the termination
              effective date; and
            </li>
            <li>
              (c) deletion/return of Customer Content occurs as described in the Agreement,
              the Privacy Policy, and (where applicable) the DPA (including plan-based
              retention and backups).
            </li>
          </ul>

          <h2 className="mb-3">12. DISCLAIMER OF WARRANTIES</h2>
          <p className="mb-2">
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, THE SERVICES ARE PROVIDED &quot;AS IS&quot;
            AND &quot;AS AVAILABLE.&quot;
          </p>
          <p className="mb-2">
            SHOOT DISCLAIMS ALL WARRANTIES, EXPRESS, IMPLIED, AND STATUTORY, INCLUDING
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT.
          </p>
          <p className="mb-5">
            WE DO NOT WARRANT THAT THE SERVICES WILL BE UNINTERRUPTED OR ERROR-FREE OR THAT
            DEFECTS WILL BE CORRECTED.
          </p>

          <h2 className="mb-3">13. LIMITATION OF LIABILITY</h2>
          <p className="mb-2">TO THE MAXIMUM EXTENT PERMITTED BY LAW:</p>
          <ul className="mb-4">
            <li>
              (a) SHOOT WILL NOT BE LIABLE FOR INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL,
              EXEMPLARY, OR PUNITIVE DAMAGES, OR FOR LOSS OF PROFITS, REVENUE, DATA, OR
              GOODWILL.
            </li>
            <li>
              (b) IN NO EVENT WILL SHOOT&apos;S TOTAL LIABILITY ARISING OUT OF OR RELATED TO
              THE AGREEMENT EXCEED THE AMOUNTS PAID (OR PAYABLE) BY CUSTOMER TO SHOOT FOR THE
              SERVICES IN THE 12 MONTHS BEFORE THE EVENT GIVING RISE TO THE CLAIM.
            </li>
          </ul>
          <p className="mb-5">
            Some jurisdictions do not allow certain limitations, so some of the above may
            not apply.
          </p>

          <h2 className="mb-3">14. INDEMNIFICATION</h2>
          <p className="mb-2">
            Customer will defend, indemnify, and hold harmless Shoot and its officers,
            directors, employees, and agents from and against any claims, damages, liabilities,
            losses, and expenses (including reasonable attorneys&apos; fees) arising out of or
            relating to:
          </p>
          <ul className="mb-5">
            <li>(a) Customer Content;</li>
            <li>
              (b) Customer&apos;s or Authorized Users&apos; use of the Services in violation of
              the Agreement or applicable law; and/or
            </li>
            <li>
              (c) Customer&apos;s failure to provide required notices, obtain required consents,
              or otherwise comply with laws relating to monitoring, privacy, data protection,
              or employment.
            </li>
          </ul>

          <h2 className="mb-3">15. EXPORT CONTROLS AND SANCTIONS</h2>
          <p className="mb-5">
            You may not use the Services in violation of U.S. export control or sanctions laws.
            You represent that you are not located in, under control of, or a national/resident
            of any country subject to comprehensive U.S. sanctions, and you are not on any U.S.
            prohibited or restricted party list.
          </p>

          <h2 className="mb-3">16. GOVERNING LAW; VENUE</h2>
          <p className="mb-2">
            These Terms are governed by the laws of the State of Georgia, excluding
            conflict-of-law rules.
          </p>
          <p className="mb-5">
            Any dispute arising out of or relating to the Agreement will be brought
            exclusively in the state or federal courts located in Fulton County, Georgia,
            and the parties consent to jurisdiction and venue there.
          </p>

          <h2 className="mb-3">17. NOTICES; CONTACT</h2>
          <h3 className="mb-3">17.1 Notices to Shoot.</h3>
          <p className="mb-2">Legal notices must be sent to legal@trustshoot.com and by mail to:</p>
          <p className="mb-2">Shoot Software Corporation (Shoot Software, Inc.)</p>
          <p className="mb-2">1799 Briarcliff Rd.</p>
          <p className="mb-2">#133237</p>
          <p className="mb-2">Atlanta, GA 30333</p>
          <p className="mb-4">United States</p>

          <h3 className="mb-3">17.2 Support.</h3>
          <p className="mb-5">
            For support or general inquiries, contact us through the Services or email the
            appropriate contact address.
          </p>

          <h2 className="mb-3">18. MISCELLANEOUS</h2>
          <ul className="mb-5">
            <li>
              (a)
              {' '}
              <strong>Assignment.</strong>
              {' '}
              Customer may not assign the Agreement without
              Shoot&apos;s prior written consent. Shoot may assign the Agreement in connection
              with a merger, acquisition, or sale of assets.
            </li>
            <li>
              (b)
              {' '}
              <strong>Severability.</strong>
              {' '}
              If any provision is unenforceable, the
              remainder remains in effect.
            </li>
            <li>
              (c)
              {' '}
              <strong>Waiver.</strong>
              {' '}
              Failure to enforce a provision is not a waiver.
            </li>
            <li>
              (d)
              {' '}
              <strong>Entire agreement.</strong>
              {' '}
              The Agreement is the complete agreement
              regarding the Services and supersedes prior or contemporaneous understandings
              on the same subject.
            </li>
            <li>
              (e)
              {' '}
              <strong>Force majeure.</strong>
              {' '}
              Neither party is liable for delays or
              failures due to events beyond reasonable control.
            </li>
          </ul>

          <h2 className="mb-3">19. COMPANY INFORMATION</h2>
          <p className="mb-2">
            Shoot Software Corporation (Shoot Software, Inc.) is a Georgia company.
          </p>
          <p className="mb-2">Privacy: privacy@trustshoot.com</p>
          <p className="mb-2">Legal: legal@trustshoot.com</p>
          <p className="mb-2">Mail:</p>
          <p className="mb-2">1799 Briarcliff Rd.</p>
          <p className="mb-2">#133237</p>
          <p className="mb-2">Atlanta, GA 30333</p>
          <p className="mb-5">United States</p>
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default TermsOfService;
